export default __webpack_public_path__ + "static/media/ReSource.56209f6e.mp4";